module.exports = __webpack_public_path__ + "img/logomarca-white.ab274439.svg";